/* Forge & Flame reskin — header drawer.
 *
 * Why this exists: Dawn's stock `<header-drawer>` resolves its owning section
 * with a hardcoded `document.getElementById('shopify-section-header')`
 * (assets/global.js). The reskin header renders as `shopify-section-header-
 * reskin`, so that lookup returns null and `openMenuDrawer` throws on the
 * first tap. This subclass keeps every bit of MenuDrawer's behaviour (focus
 * trap, Escape, submenu transitions) and only swaps the header lookup for a
 * section-agnostic `closest()`.
 *
 * Loaded with `defer` AFTER global.js, so MenuDrawer is already defined.
 */
(function () {
  if (typeof MenuDrawer === 'undefined') {
    // global.js failed or load order changed — leave the <details> as a plain
    // native disclosure rather than throwing. The menu still opens.
    return;
  }

  class ReskinHeaderDrawer extends MenuDrawer {
    openMenuDrawer(summaryElement) {
      this.header = this.header || this.closest('.shopify-section');
      if (this.header) {
        // The drawer is positioned from the header's bottom edge.
        const wrapper = this.closest('.header-wrapper');
        const borderOffset = wrapper && wrapper.classList.contains('header-wrapper--border-bottom') ? 1 : 0;
        document.documentElement.style.setProperty(
          '--header-bottom-position',
          `${parseInt(this.header.getBoundingClientRect().bottom - borderOffset, 10)}px`
        );
        this.header.classList.add('menu-open');
      }

      setTimeout(() => {
        this.mainDetailsToggle.classList.add('menu-opening');
      });

      summaryElement.setAttribute('aria-expanded', true);
      trapFocus(this.mainDetailsToggle, summaryElement);
      document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
    }

    closeMenuDrawer(event, elementToFocus) {
      // MenuDrawer.closeMenuDrawer, not HeaderDrawer's — ours owns the header class.
      super.closeMenuDrawer(event, elementToFocus);
      if (this.header) this.header.classList.remove('menu-open');
    }
  }

  if (!customElements.get('reskin-header-drawer')) {
    customElements.define('reskin-header-drawer', ReskinHeaderDrawer);
  }
})();
